import React, { useState } from 'react';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { onEnterAction } from '../utils/a11y';

interface Props {
  children: React.ReactNode;
  title: string;
  defaultOpen?: boolean;
  headerClassName?: string;
}

export const AccordionItem = ({ children, title, defaultOpen = false, headerClassName }: Props): JSX.Element => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const containerStyles = `shadow-md border-b${!isOpen ? ' hover:bg-gray-100' : ''}`;

  return (
      <div className={containerStyles}>
        <div
          aria-label={title}
          className={`flex items-center cursor-pointer p-4${headerClassName ? ` ${headerClassName}` : ''}`}
          onClick={(): void => setIsOpen(!isOpen)}
          onKeyDown={(e): void => onEnterAction(e, (): void => setIsOpen(!isOpen))}
          role='button'
          tabIndex={0}
        >
          <div className='flex-grow font-medium'>{title}</div>
          <div className='flex-shrink-0 text-gray-400 pl-2'>
            <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
          </div>
        </div>
        {isOpen && (
          <div className='px-4 pt-3 pb-3'>
            {children}
          </div>
        )}
      </div>
  );
};
